'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { MoveUpRightIcon } from 'lucide-react';
import { trackStatistic } from '@/lib/utils/statisticTracker';
import { useGetTopCountWorks } from '@/features/jobs';
import { TopProfessionDto } from '@/shared/job/job.public.dto';

const listPath = '/job/list';

export default function TopCountWorks() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const { data } = useGetTopCountWorks();
  const works = data?.data ?? [];
  const selectedCategory = searchParams.get('professionIds');
  const selectedMinSalary = searchParams.get('salaryMin');
  const selectedMaxSalary = searchParams.get('salaryMax');

  const formatSalary = (salary: number) => {
    return new Intl.NumberFormat('mn-MN').format(salary) + '₮';
  };

  const onClick = (profession: TopProfessionDto) => {
    trackStatistic('top_profession');
    const categories = [
      profession.id,
      ...(profession.profs_data ?? []).map((p) => p.id),
    ].join(',');
    const url = `${listPath}?professionIds=${encodeURIComponent(categories)}&salaryMin=${profession.min_salary}&salaryMax=${profession.max_salary}`;
    return router.replace(url);
  };

  return (
    <div className="px-4 bg-white rounded-xl py-4 mb-4">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary-500 rounded-lg">
          <MoveUpRightIcon className="text-white w-4 h-4" />
        </div>
        <span className="font-medium">Хамгийн олон зарлагдсан ажлын байр</span>
      </div>
      <div className="space-y-3 mt-3">
        {works.map((work: TopProfessionDto, index) => {
          const isSelected =
            selectedCategory?.includes(work.id.toString()) &&
            selectedMinSalary === work.min_salary.toString() &&
            selectedMaxSalary === work.max_salary.toString();
          return (
            <div
              key={work.id}
              className={`relative overflow-hidden hover:bg-primary-50 transition-colors cursor-pointer border border-gray-100 py-2 pl-7 pr-2 rounded-xl ${
                isSelected
                  ? 'bg-primary-50 border-gray-300'
                  : 'border-gray-100 hover:bg-primary-50'
              }`}
              onClick={() => onClick(work)}
            >
              <div className="absolute top-0 left-0 bg-[#E6F0FA] text-[#005BB8] text-xs font-medium w-5 h-5 rounded-tl-md rounded-br-md flex items-center justify-center">
                {index + 1}
              </div>
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-semibold text-gray-900">
                  {work.profession}
                </h3>
                <span className="inline-flex items-center text-xs text-gray-700 bg-gray-100 px-3 py-1 rounded-2xl">
                  {work.count}
                </span>
              </div>
              <p className="text-sm text-gray-600">
                {formatSalary(work?.min_salary)} -{' '}
                {formatSalary(work?.max_salary)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
